export const addSecondsToCurrentTime = (seconds: any) => {
  const currentDate = new Date();
  const newDate = new Date(currentDate.getTime() + seconds);
  return newDate.getTime();
};
